module.exports = __webpack_public_path__ + "img/w3_cart_light.c67ec659.png";